import { render } from "./LeituraQRCode.vue?vue&type=template&id=d7c63a44&scoped=true"
import script from "./LeituraQRCode.vue?vue&type=script&lang=js"
export * from "./LeituraQRCode.vue?vue&type=script&lang=js"

import "./LeituraQRCode.vue?vue&type=style&index=0&id=d7c63a44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7c63a44"]])

export default __exports__